import { Link } from 'react-router-dom'
import React from 'react'
import { t } from 'ttag'

import { stripHtmlTagsFromString } from '../../../actions'

const RelatedItemRecommendation = ({ recommendations }) => {
  const maxLength = 300
  const trimDesc = str => {
    return str?.length > maxLength ? `${str.substring(0, maxLength)}...` : str
  }

  return (
    <div className="recommendations col-sm-3">
      <h3 style={{ color: 'black' }}>{t`Programs to Consider`}</h3>
      <ul className="recommendation-listing">
        {recommendations?.items?.map(r => (
          <li key={r.url}>
            <div className="inlist-recommendation">
              {r.image ? (
                <div className="text-center">
                  <img
                    src={r.image}
                    alt={t`Thumbnail for ${r.title}`}
                    aria-hidden={true}
                  />
                </div>
              ) : null}
              <h3>{r.title}</h3>
              <p>{trimDesc(stripHtmlTagsFromString(r.description, true))}</p>
              <Link to={r.url} className="btn btn-success no-style pull-right">
                {t`Find out More`}
              </Link>
              <br className="clear" />
            </div>
          </li>
        ))}
      </ul>
    </div>
  )
}

export default RelatedItemRecommendation
